import Mute from '@/javascripts/components/Mute';

const mute = new Mute({ isCardLayout: true });

document.addEventListener('DOMContentLoaded', () => {
  mute.addToggleMuteEvent();
});
